import { Modal, Spin } from 'antd'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
// import 'dayjs/locale/fr'
import React, { useEffect, useState } from 'react'
import { useGetConferencesQuery, useSetConferenceParticipationMutation } from '../../../api/v2/conferencesV2'
import { useMyContext } from '../../../context/context'
import useSettingsV2 from '../../../hooks/useSettingsV2'
import { useSteps } from '../Steps'

dayjs.locale('fr')
dayjs.extend(utc)

// Époque MURALE : l'heure saisie au BO, exprimée en UTC — se lit en UTC, jamais dans le
// fuseau du participant (voir api/src/helpers/wallEpoch.js).
function formatTimestampToShortDate(ts) {
  return dayjs.utc(ts).format('ddd DD/MM')
}

function formatTimestampToHour(ts) {
  return dayjs.utc(ts).format('HH[h]mm')
}

const disabledTextColor = '#A4A4A4'

function Conference({ c, setParticipation, primaryColor, disabledColor }) {
  const [open, setOpen] = useState(true)

  const { myContext } = useMyContext()

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div
        style={{
          backgroundColor: c.disabled ? disabledColor : primaryColor,
          textAlign: 'center',
          color: 'white',
          fontWeight: 700,
          borderRadius: 50,
          padding: '8px 16px',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <div style={{ flexGrow: 1 }}>
          <div
            style={{
              textAlign: 'center',
              color: c.disabled ? disabledTextColor : 'white',
              fontWeight: 700,
            }}
          >
            {c.title}
          </div>
          {c.coworkerRegistered ? (
            <div style={{ color: disabledTextColor, fontStyle: 'italic', fontSize: '0.8rem' }}>
              Un collaborateur de l’entreprise est déjà inscrit
            </div>
          ) : null}
          {c.maxReached && !c.coworkerRegistered ? (
            <div style={{ color: disabledTextColor, fontStyle: 'italic', fontSize: '0.8rem' }}>Vous avez atteint le quota maximum</div>
          ) : null}
        </div>
        <div style={{ cursor: 'pointer' }} onClick={() => setOpen(!open)}>
          {open ? '-' : '+'}
        </div>
      </div>
      {c?.description?.html ? <div dangerouslySetInnerHTML={{ __html: c.description.html }} /> : null}
      {open && (
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 16,
            justifyContent: 'center',
          }}
        >
          {c.slots.map(s => {
            const blockStyles = {
              border: '1px solid black',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              padding: '4px 16px',
              color: 'black',
              cursor: 'pointer',
            }
            let message = 'Disponible'

            if (s.registered) {
              blockStyles.border = `1px solid ${primaryColor}`
              blockStyles.color = 'white'
              blockStyles.backgroundColor = primaryColor
              message = 'Inscrit'
            } else if (s.disabled) {
              blockStyles.border = `1px solid ${disabledColor}`
              blockStyles.color = disabledTextColor
              blockStyles.backgroundColor = disabledColor
              blockStyles.cursor = 'not-allowed'
              message = 'Complet'
              if (c.coworkerRegistered || c.maxReached || s.overlap) {
                message = 'Indisponible'
              }
            }

            const timeStyles = { fontWeight: 700, color: primaryColor, fontSize: '1.1em' }
            if (s.registered) {
              timeStyles.color = 'white'
            } else if (s.disabled) {
              timeStyles.color = disabledTextColor
            }

            return (
              <div
                style={blockStyles}
                onClick={() => {
                  if (!s.disabled || s.registered) {
                    if (c.registered && s.registered) {
                      Modal.confirm({
                        title: 'Confirmation',
                        content: 'Êtes-vous sûr de vouloir vous désinscrire de ce créneau horaire ?',
                        okText: 'Oui',
                        cancelText: 'Non',
                        onOk: () => setParticipation({ ...myContext, slotId: s.id }),
                      })
                    } else if (c.registered) {
                      Modal.confirm({
                        title: 'Confirmation',
                        content: 'Êtes-vous sûr de vouloir changer de créneau horaire ?',
                        okText: 'Oui',
                        cancelText: 'Non',
                        onOk: () => setParticipation({ ...myContext, slotId: s.id }),
                      })
                    } else {
                      setParticipation({ ...myContext, slotId: s.id })
                    }
                  }
                }}
              >
                <div style={{ textTransform: 'capitalize', fontWeight: 600 }}>{formatTimestampToShortDate(s.startAt)}</div>
                <div style={timeStyles}>
                  {formatTimestampToHour(s.startAt)}-{formatTimestampToHour(s.endAt)}
                </div>
                <div style={{ fontWeight: 600 }}>{message}</div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default function ConferencesV2() {
  const [current, setCurrent] = useState()

  const { myContext } = useMyContext()
  const { settings } = useSettingsV2()

  const { NextButton, nextStep } = useSteps()

  const { data: conferences } = useGetConferencesQuery({ ...myContext })
  const [setParticipation, { isLoading }] = useSetConferenceParticipationMutation()

  const primaryColor = settings?.FO_MEETING_CONFERENCES_V2_COLOR
  const disabledColor = '#E5E5E5'

  useEffect(() => {
    if (conferences && !current) {
      const [first] = conferences.filter(f => !f.disabled)
      setCurrent(first?.id)
    }
  }, [conferences, current])

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      {settings?.FO_MEETING_CONFERENCES_V2_HTML && <div dangerouslySetInnerHTML={{ __html: settings.FO_MEETING_CONFERENCES_V2_HTML }} />}
      <Spin spinning={isLoading} size="small">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          {conferences?.map(c => (
            <Conference c={c} setParticipation={setParticipation} primaryColor={primaryColor} disabledColor={disabledColor} />
          ))}
        </div>
      </Spin>
      <NextButton onClick={() => nextStep()} />
    </div>
  )
}
